import type { ApiFilestackImageData } from 'api/types/ApiFilestackImageData';
import { FilestackImage } from 'components/FilestackImage/FilestackImage';
import { ActionOppsIcon } from 'components/Icon/ActionOpps/ActionOppsIcon';
import type { ActionOppsIconName } from 'components/Icon/ActionOpps/ActionOppsIconName';

import { SearchHitImageLogo } from './SearchHitImageLogo';

type Props = {
  isImported: boolean;
  imageUrl: string | null;
  image: ApiFilestackImageData | null;
  source: string | null;
  name: string;
  logo: ApiFilestackImageData | null;
};

const SEARCH_HIT_IMAGE_SIZE = 120;

export function SearchHitImage({
  isImported,
  imageUrl,
  image,
  source,
  name,
  logo,
}: Props) {
  if (isImported && !imageUrl && source) {
    const actionOppsIconName = source
      .toLowerCase()
      .replace(/_/g, '-') as ActionOppsIconName;

    return (
      <ActionOppsIcon
        name={actionOppsIconName}
        width={SEARCH_HIT_IMAGE_SIZE}
        maxWidth="100%"
        maxHeight="100%"
      />
    );
  }

  if (imageUrl) {
    return (
      <img
        src={imageUrl}
        alt=""
        width="100%"
        height="100%"
        style={{
          objectFit: 'contain',
          objectPosition: 'center center',
        }}
      />
    );
  }

  if (image) {
    return (
      <FilestackImage
        data={image}
        width={SEARCH_HIT_IMAGE_SIZE}
        expandSize
        objectPosition="top center"
        noCrop
      />
    );
  }

  return (
    <SearchHitImageLogo
      width={SEARCH_HIT_IMAGE_SIZE}
      height={SEARCH_HIT_IMAGE_SIZE}
      name={name}
      logo={logo}
    />
  );
}
